import type React from 'react';
import styles from './divider.module.scss';

export interface WordsHappenDividerProps {
  /** Short text centred between two hairlines, e.g. "or". */
  label?: React.ReactNode;
  className?: string;
}

/**
 * A 1.5px --wh-line hairline, optionally split by a centred uppercase label. The label uses
 * --wh-ink-soft, since --wh-ink-faint falls short of 4.5:1 on every theme.
 */
export const WordsHappenDivider: React.FC<WordsHappenDividerProps> = ({ label, className }) => {
  const cls = [styles.divider, className].filter(Boolean).join(' ');

  if (label === undefined || label === null || label === '') {
    return <div role="separator" className={cls} />;
  }

  return (
    <div className={cls}>
      <span aria-hidden="true" className={styles.line} />
      <span className={styles.label}>{label}</span>
      <span aria-hidden="true" className={styles.line} />
    </div>
  );
};
